import React,{useState,useEffect} from "react";
import {Link} from "react-router-dom";
import Table from "../../../../../core/dataTable/non-pager/index";
import ImageWithBasePath from "../../../../../core/img";
import {all_routes} from "../../../../router/all_routes";
import {Toaster} from 'react-hot-toast';
/* -- biz9 import start -- */
import {UrlQuery} from "biz9-react-utility";
import {Str,DateTime,Log} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {User_Logic} from "biz9-user";
import {Message,Type,Url,Field,Title} from "../../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Toast_Message,Storage,System} from "../../../../../project";
import {Data_Logic} from "biz9-data-app";
import {Portal_Table} from "biz9-portal-app";
/* -- biz9 import end -- */
const Dashboard_App_Order_Detail = () => {
   const query = UrlQuery();
   const [user,setUser] = useState(User_Logic.get_test({blank:true}));
   const [product,setProduct] = useState(Data_Logic.get(Portal_Table.PRODUCT,0));
   const [order,setOrder] = useState(Data_Logic.get(Portal_Table.ORDER,0));
   const [val_order_number,setValOrderNumber] = useState(null);
   const [val_hosting_type,setValHostingType] = useState("");
   const [val_cms_type,setValCmsType] = useState("");
   const [payments,setPayments] = useState([]);
 const order_payment_columns = [
 {
title: "Transaction ID",
       dataIndex: "transaction_id",
       render: (text: string, record: any) => (
               <>
                {record.transaction_id}
                </>
               ),
       sorter: (a: any, b: any) => a.transaction_id.length - b.transaction_id.length,
    },

    {
title: "Payment Amount",
       dataIndex: "payment_amount",
       render: (text: string, record: any) => (
               <>
                {Str.get_money(record.payment_amount)}
                </>
               ),
       sorter: (a: any, b: any) => a.payment_amount.length - b.payment_amount.length,
    },
 {
title: "Payment Method",
       dataIndex: "payment_method_type",
       render: (text: string, record: any) => (
               <>
                {record.payment_method_type}
                </>
               ),
       sorter: (a: any, b: any) => a.payment_method_type.length - b.payment_method_type.length,
    },
 {
title: "Date & Time",
       dataIndex: "payment_method_type",
       render: (text: string, record: any) => (
               <>
                {DateTime.get_date(record.date_create)}{" "}
                {DateTime.get_time(record.date_create)}
                </>
               ),
       sorter: (a: any, b: any) => a.date_create.length - b.date_create.length,
    },


    ];
	useEffect(() => {
        Toast_Message.loading(Message.LOADING);
		if(!Str.check_is_null(query.get('order_number'))){
			get_data();
		}
	},[val_order_number]);
    async function get_data() {
        /*
	let [response,data] = await Portal_Remote_Data.get(App.get_url(Portal_Url),Data_Url.ORDER,{order_number:'order_number'});
    setUser(data.parent_user);
    setOrder(data.order);
    setProduct(data.order.order_items[0].parent_item);
    setPayments(data.order_payments);
    setValHostingType(data.order.order_items[0].order_sub_items.find(item_find => item_find.parent_id === data.order.hosting_type_id).parent_item ? data.order.order_items[0].order_sub_items.find(item_find => item_find.parent_id === data.order.hosting_type_id).parent_item.title : "N/A");
    setValCmsType(data.order.order_items[0].order_sub_items.find(item_find => item_find.parent_id === data.order.cms_type_id).parent_item ? data.order.order_items[0].order_sub_items.find(item_find => item_find.parent_id === data.order.cms_type_id).parent_item.title : "N/A");
    Toast_Message.dismiss();
    */
   }
  return (
    <>
            <Toaster />
      {/* Page Content */}
      <div className="page-wrapper">
        <div className="page-content content">
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <div className="main-title mb-4">
                <h4>Order</h4>
              </div>
              <div className="card profile-card">
                <div className="card-body">
                  <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap">
                    <div className="d-flex align-items-center flex-shrink-0">
                      <span className="avatar avatar-lg">
                    <Link to={all_routes.dashboard_user_profile_detail+"?user_id="+user.id} className="text-dark">
                        <ImageWithBasePath className="rounded-2" src={Image.get_url(user.image_filename,Image_Format.SQUARE_THUMB)} alt="img" />
                    </Link>
                      </span>
                      <div className="ms-3">
                        <h6 className="mb-1 d-inline-flex flex-wrap align-items-center">
                          {user.title?user.title:"N/A"}
                        </h6>
                        <p className="mb-2">{user.email}</p>
                        <p className="mb-2">{User_Logic.get_country_state_city(user)}</p>
                      </div>
                    </div>
                    <Link to={'#'} className="btn btn-lg btn-dark">
                      <i className="ti ti-user-edit me-1" />
                       Profile
                    </Link>
                  </div>
                </div>
              </div>

            <div className="card profile-details">
                <div className="card-header">
                <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap ">
                    <div className="d-flex align-items-center flex-shrink-0">
                        <h5 className="mb-0">Application Details</h5>
                  </div>
                     <Link to={'#'} className="btn btn-lg btn-dark" style={{ float: 'right' }}>
                      <i className="ti ti-user-edit me-1" />
                       App
                    </Link>
                </div>
                </div>
                <div className="card-body">
                  <div className="row row-gap-3">
                    <div className="col-md-4 col-sm-6">
                      <h6>Title</h6>
                      <p className="mb-0">{product.title}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Content Management System Type</h6>
                      <p className="mb-0">{val_cms_type}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Hosting Duration</h6>
                      <p className="mb-0">{val_hosting_type}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Application Type</h6>
                      <p className="mb-0">{product.application_type}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Delivery Time</h6>
                      <p className="mb-0">{product.delivery_time}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Blank</h6>
                      <p className="mb-0">{""}</p>
                    </div>
                  </div>
                </div>
              </div>


              <div className="card profile-details">
                <div className="card-header">
                  <h5 className="mb-0">Order Details</h5>
                </div>
                <div className="card-body">
                  <div className="row row-gap-3">
                    <div className="col-md-4 col-sm-6">
                      <h6>Grand Total</h6>
                      <p className="mb-0">{Str.get_money(order.grand_total)}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Order #</h6>
                      <p className="mb-0">{order.order_number}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Date & Time</h6>
                      <p className="mb-0">{DateTime.get_date(order.date_create)}{" "}{DateTime.get_time(order.date_create)}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Blank</h6>
                      <p className="mb-0">{' '}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Blank</h6>
                      <p className="mb-0">{" "}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Payment Plan Type</h6>
                      <p className="mb-0">{order.payment_plan_type}</p>
                    </div>
                  </div>
                </div>
              </div>

            <div className="card profile-details">
                <div className="card-header">
                  <h5 className="mb-0">Payment Details</h5>
                </div>
                <div className="card-body">
                  <div className="row row-gap-3">
  <div className="table-responsive custom-table">
            <Table allow_multiple={false}  table={Portal_Table.ORDER} dataSource={payments} columns={order_payment_columns} Selection={false} />
            </div>

                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
      {/* /Page Content */}
    </>
  );
};

export default Dashboard_App_Order_Detail;
